import { apiClient, unwrap } from '@services/api';
import type { LandingData } from '@/types';

export const marketingService = {
  async getLandingData(): Promise<LandingData> {
    const res = await apiClient.get<LandingData>('/landing');
    return unwrap(res);
  },
};
